import { useContext } from 'react';
import './style.scss';
import { ReactComponent as UploadPlus } from '../../upload-plus.svg';
import { ReactComponent as UploadX } from '../../upload-x.svg';
import { FormDataContext } from '../FormDataProvider';

function WorkStep() {

  const { formData, handleFileChange, handleFileRemove } = useContext(FormDataContext);

  return (
    <div className="work-step">
      <h2>Arbetsprover / arbetsmeriter</h2>
      <p className="desc">Ladda upp ditt anställningsavtal, bilder på fem arbetsprover tillsammans med en beskrivning av din roll. Sammanställ i en och samma PDF.</p>
        <form>
              <label className="full">
                <div className="file-upload">
                    <UploadPlus />
                    <h3>Ladda upp dina filer</h3>
                    <span>Eller välj mapp. pdf, png, jpg eller jpeg. Max 10mb.</span>
                    <input type="file" name="work_files" multiple accept="application/pdf, image/png, image/jpeg, image/jpg" className="hidden" onChange={(e) => handleFileChange(e)} required />
                </div>
              </label>
              {formData && formData['work_files'] != undefined && formData['work_files'].length && <div className="file-upload-list">
                <p>Uppladdade filer</p>
                {formData['work_files'].map((file, index) => (
                  <div className="file-upload-list-item" key={index}>
                    <div className="file-upload-list-item-file">
                    <span>{file.name}</span>
                    <UploadX name="work_files" pid={file.material_pid && file.material_pid} onClick={(e) => handleFileRemove(e)} />
                    </div>
                </div>
                ))}
              </div>}
        </form>
    </div>
  );
}

export default WorkStep;
